<div class="stat-grid">
    <app-stat-card
            title="Total<br>Trips"
            [value]="total_trips"
            icon="local_shipping"
            variant="primary">
    </app-stat-card>

    <app-stat-card
            title="Total<br>Deliveries"
            [value]="total_deliveries"
            icon="directions_walk"
            variant="warning">
    </app-stat-card>

    <app-stat-card
            title="Total<br>Amount"
            [value]="total_amount"
            icon="attach_money"
            variant="success">
    </app-stat-card>

    <app-stat-card
            title="Unpaid<br>Trips"
            [value]="total_trips"
            icon="inventory_2"
            variant="danger">
    </app-stat-card>
</div>

<app-filter-bar
        [fields]="fields"
        [initialValues]="{}"
        (apply)="onApply($event)"
        (reset)="onReset()">
</app-filter-bar>


<!-- Upload toolbar (new) -->
<div class="upload-toolbar">
    <button mat-flat-button color="primary" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Upload CSV
    </button>
    <button mat-flat-button color="primary" (click)="downloadReport()">
        <mat-icon>download_file</mat-icon>
        Download Report
    </button>
    <input #fileInput type="file" accept=".csv" (change)="onFileSelected($event)" hidden>

    <span class="file-name" *ngIf="selectedFileName">{{ selectedFileName }}</span>

    <span class="spacer"></span>

    <button mat-stroked-button color="primary" (click)="refresh(null)" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
    </button>
</div>
<!-- Optional progress -->
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<!-- Table -->
<div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1" [multiTemplateDataRows]="true">

        <!-- Trip Number -->
        <ng-container matColumnDef="trip_number">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Trip #</th>
            <td mat-cell *matCellDef="let row"> {{ row.trip_number }}</td>
        </ng-container>

        <!-- Rider -->
        <ng-container matColumnDef="rider_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Rider</th>
            <td mat-cell *matCellDef="let row">
                {{ row.rider_name || '-' }} <span class="muted" *ngIf="row.rider_name">({{ row.rider_code }})</span>
            </td>
        </ng-container>

        <!-- Start -->
        <ng-container matColumnDef="start_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Start</th>
            <td mat-cell *matCellDef="let row"> {{ row.start_time | date:'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <!-- End -->
        <ng-container matColumnDef="end_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> End</th>
            <td mat-cell *matCellDef="let row"> {{ row.end_time | date:'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <!-- Distance -->
        <ng-container matColumnDef="actual_distance">
            <th mat-header-cell *matHeaderCellDef> Distance (km)</th>
            <td mat-cell *matCellDef="let row">{{ row.actual_distance }}</td>
        </ng-container>

        <!-- Distance -->
        <ng-container matColumnDef="payment_amount">
            <th mat-header-cell *matHeaderCellDef> Payment Amount({{currency}})</th>
            <td mat-cell *matCellDef="let row">{{ row.payment_amount }}</td>
        </ng-container>

        <!-- Deliveries (count) -->
        <ng-container matColumnDef="deliveries">
            <th mat-header-cell *matHeaderCellDef> Deliveries</th>
            <td mat-cell *matCellDef="let row">
                {{ row.deliveries?.length || 0 }}
            </td>
        </ng-container>

        <!-- Created -->
        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created</th>
            <td mat-cell *matCellDef="let row"> {{ row.created_at | date:'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions</th>
            <td mat-cell *matCellDef="let row">
                <button mat-stroked-button color="primary" (click)="viewTrip(row)">
                    <span class="btn-label">{{ expandedElement === row ? 'Hide' : 'View' }}</span>
                </button>


            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <!-- declare the column WITHOUT *ngIf -->
        <ng-container matColumnDef="detail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                <!-- here 'row' is in scope -->
                <ng-container *ngIf="expandedElement === row">
                    <div class="detail-wrapper">
                        <table class="inner-table" *ngIf="row.deliveries?.length; else noDeliveries">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>CCC</th>
                                <th>Drug Refill Date</th>
                                <th>Preferred Delivery Date</th>
                                <th>Payment Type</th>
                                <th>Amount</th>
                                <th>Narration</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let d of row.deliveries">
                                <td>{{ d.id }}</td>
                                <td>{{ d.ccc || '-' }}</td>
                                <td>{{ d.drug_refill_date || '-' }}</td>
                                <td>{{ d.prefered_delivery_date || '-' }}</td>
                                <td>{{ d.payment_type || '-' }}</td>
                                <td>{{ d.amount || '-' }}</td>
                                <td>{{ d.narration || '-' }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <ng-template #noDeliveries>
                            <div class="muted">No deliveries linked to this trip.</div>
                        </ng-template>
                    </div>
                </ng-container>
            </td>
        </ng-container>
        <tr
                mat-row
                *matRowDef="let row; columns: ['detail']"
                class="detail-row"
                [@detailExpand]="expandedElement === row ? 'expanded' : 'collapsed'">
        ></tr>


    </table>

    <mat-paginator [length]="total_trips"
                   [pageSize]="pageSize"
                   [pageIndex]="filters.page - 1"
                   [pageSizeOptions]="[10,25,50,100]"
                   (page)="onPage($event)">
    </mat-paginator>
</div>

